var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { TextS } from '../typography/typography';
import { InputEvents } from './types';
var dispatchUpdateCountEvent = function (id, count, limit) {
    if (!limit)
        return;
    var event = new CustomEvent(InputEvents.UPDATE_COUNT, {
        detail: {
            id: id,
            count: count,
            limit: limit,
        },
    });
    document.dispatchEvent(event);
};
export var Input = forwardRef(function (_a, forwardedRef) {
    var _b, _c, _d;
    var errorMessage = _a.errorMessage, successMessage = _a.successMessage, startIcon = _a.startIcon, endIcon = _a.endIcon, disabled = _a.disabled, className = _a.className, InfoMessage = _a.InfoMessage, onChange = _a.onChange, value = _a.value, maxLength = _a.maxLength, id = _a.id, rest = __rest(_a, ["errorMessage", "successMessage", "startIcon", "endIcon", "disabled", "className", "InfoMessage", "onChange", "value", "maxLength", "id"]);
    var internalInputRef = useRef(null);
    useImperativeHandle(forwardedRef, function () {
        var inputElement = internalInputRef.current;
        return Object.assign(inputElement, {
            getCharacterCount: function () { return inputElement.value.length; },
            getCharacterLimit: function () { return (inputElement.maxLength === -1 ? undefined : inputElement.maxLength); },
            getInputId: function () { return inputElement.id || undefined; },
        });
    }, []);
    var handleChange = function (event) {
        var currentValue = event.target.value;
        dispatchUpdateCountEvent(id, currentValue.length, maxLength);
        if (onChange) {
            onChange(event);
        }
    };
    // Ensures that a correct limit is set for the initial value
    useEffect(function () {
        dispatchUpdateCountEvent(id, String(value || '').length, maxLength);
    }, [value, maxLength, id]);
    return (_jsxs("div", { className: styles.container, children: [_jsxs("div", { className: "u-position-relative", children: [startIcon && (_jsx("div", { className: classNames(styles['start-icon'], (_b = {}, _b[styles['is-disabled']] = disabled, _b)), children: startIcon })), _jsx("input", __assign({ ref: internalInputRef, id: id, className: classNames(styles.input, className, (_c = {},
                            _c[styles['with-start-icon']] = !!startIcon,
                            _c[styles['with-end-icon']] = !!endIcon,
                            _c[styles['is-error']] = !!errorMessage,
                            _c[styles['is-success']] = !!successMessage,
                            _c[styles['is-disabled']] = disabled,
                            _c)), disabled: disabled, onChange: handleChange, value: value, maxLength: maxLength }, rest)), endIcon && (_jsx("div", { className: classNames(styles['end-icon'], (_d = {}, _d[styles['is-disabled']] = disabled, _d)), children: endIcon }))] }), errorMessage && (_jsx(TextS, { color: "negative", className: styles['additional-message'], children: errorMessage })), successMessage && (_jsx(TextS, { color: "positive", className: styles['additional-message'], children: successMessage })), InfoMessage && (_jsx(TextS, { color: disabled ? 'disabled' : 'tertiary', className: styles['additional-message'], children: InfoMessage }))] }));
});
Input.displayName = 'Input';
